import { store } from '@/store'
import firebase from 'firebase/app'
const db = firebase.firestore()

const state = {
  publicSubjects: [],
  publicWebinars: []
}

const actions = {
  GET_PUBLIC_SUBJECTS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('subjects')
      let unsub = ref.onSnapshot(snapshot => {
        let subjects = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          if (doc.data().isActive) {
            subjects.push(log)
          }
        })
        commit('SET_LOADED_PUBLIC_SUBJECTS', subjects)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  GET_STUDENT_SUBJECTS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('subjects')
      let unsub = ref.onSnapshot(snapshot => {
        let subjects = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          if (doc.data().isActive) {
            subjects.push(log)
          }
        })
        commit('SET_LOADED_PUBLIC_SUBJECTS', subjects)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  ADD_SUBJECT_TO_STUDENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('students').doc(payload.student).update({
        subjects: firebase.firestore.FieldValue.arrayUnion(payload.subject)
      }).then(snapshot => {
        resolve(snapshot)
      })
    })
  },
  SAVE_ANSWER_TO_QUESTION ({ commit }, payload) {
    var student = store.state.auth.user.id
    return new Promise((resolve, reject) => {
      db.collection('students')
        .doc(student)
        .collection('answers')
        .doc(payload.subject)
        .set({
          [payload.variant]: {
            currentQuestion: payload.question,
            [payload.question]: {
              answer: payload.answer,
              isCorrect: payload.isAnswerCorrect
            }
          }
        }, { merge: true })
        .then(snapshot => {
          resolve(snapshot)
        }, (error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  GET_STUDENT_ANSWERS ({ commit }, payload) {
    var student = store.state.auth.user.id
    return new Promise((resolve, reject) => {
      db.collection('students').doc(student).collection('answers').doc(payload).get().then((doc) => {
        if (doc) {
          commit('SET_STUDENT_ANSWERS', doc.data())
        }
      }).then(snapshot => {
        resolve(snapshot)
      }, (error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  GET_PUBLIC_WEBINARS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('webinars')
      let unsub = ref.onSnapshot(snapshot => {
        let webinars = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          if (doc.data().isActive) {
            webinars.push(log)
          }
        })
        commit('SET_LOADED_PUBLIC_WEBINARS', webinars)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  }
}

const getters = {
}

const mutations = {
  SET_LOADED_PUBLIC_SUBJECTS (state, payload) {
    state.publicSubjects = payload
  },
  SET_LOADED_PUBLIC_WEBINARS (state, payload) {
    state.publicWebinars = payload
  },
  SET_STUDENT_ANSWERS (state, payload) {
    state.answers = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
